import { refillsQueryFilterOptions } from "./types";


export const refillsKeys = {
    all: ["refills"] as const,
    refills: (opts: refillsQueryFilterOptions) => [...refillsKeys.all, opts] as const,
} as const;


